import React from 'react';
import { ImagePath } from '../Utility';

const ImageComponents = ({ name, className }) => {
  return (
    <img src={ImagePath[name]} alt={name} className={className} />
  );
};
export default ImageComponents;